import { render } from "./unSyncDocs.vue?vue&type=template&id=222cb31d"
import script from "./unSyncDocs.vue?vue&type=script&lang=js"
export * from "./unSyncDocs.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__